import { motion } from "framer-motion";

export default function MeasurementDivider({ label }) {
  return (
    <div
      data-testid="measurement-divider"
      className="relative w-full py-12 flex items-center"
    >
      <motion.div
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        className="absolute left-0 right-0 h-px bg-white/15 origin-left"
      />
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-2 h-2 border-l border-t border-messinger-orange" />
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 border-r border-t border-messinger-orange" />
      {label && (
        <div className="relative mx-auto bg-messinger-bg px-4 text-[10px] tracking-[0.3em] uppercase text-white/40">
          {label}
        </div>
      )}
    </div>
  );
}
